import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 4v6l-2 4v2h10v-2l-2 -4v-6","key":"svg-0"}],["path",{"d":"M12 16l0 5","key":"svg-1"}],["path",{"d":"M8 4l8 0","key":"svg-2"}]]

/**
 * IconPinned
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGlubmVkIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik05IDR2NmwtMiA0djJoMTB2LTJsLTIgLTR2LTYiIC8+CiAgPHBhdGggZD0iTTEyIDE2bDAgNSIgLz4KICA8cGF0aCBkPSJNOCA0bDggMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/pinned
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPinned = createReactComponent('outline', 'pinned', 'Pinned', __iconNode);

export default IconPinned;